"use strict";

class RundownDraftsCtrl {
    constructor($compile, $http, $scope, selector, $state, $rootScope, rundownInfo, widgets, UserFilters, itemModelTypes, masterStationInfo, yConnection, yDraftConnections) {
        this.$compile = $compile;
        this.$http = $http;
        this.$scope = $scope;
        this.selector = selector;
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.rundownInfo = rundownInfo;
        this.widgets = widgets;
        this.UserFilters = UserFilters;
        this.itemModelTypes = itemModelTypes;
        this.masterStationInfo = masterStationInfo;
        this.yConnection = yConnection;
        this.yDraftConnections = yDraftConnections;

        this.userId = window.CONFIG.user_id;
        this.programId = this.rundownInfo.broadcast.program.id;
        this.stationId = masterStationInfo.masterStationId;
        this.slaveStation = !masterStationInfo.isMasterStation;
        this.readOnly = this.readOnly || this.slaveStation;
        this.customFields = {};
        this.currentNavItem = 'live';

        this.filterMap = [];
        this.UserFilters.get((data) => {
            this.filterMap = data.userFilters;
        });

        this.customFieldsRaw = itemModelTypes;
        itemModelTypes.forEach((data) => {
            this.customFields[data.id] = data.fields;
        });


        this.deepObserver = function () {
            this.$scope.$evalAsync(); //update scope if we get an update while we are not focused
        }.bind(this);

        this.$scope.$on('$destroy', this.destroy.bind(this));

        this.initView();
    }


    initView() {
        const {yDraftConnections, deepObserver} = this;

        const yPersonal = this.yPersonal = yDraftConnections.personal.getArray('items');
        const yProgram = this.yProgram = yDraftConnections.program.getArray('items');
        const yStation = this.yStation = yDraftConnections.station.getArray('items');

        this.selector.addDrafts(yPersonal, yProgram, yStation);

        yPersonal.observeDeep(deepObserver);
        yProgram.observeDeep(deepObserver);
        yStation.observeDeep(deepObserver)
    }


    destroy() {
        const {deepObserver, yPersonal, yProgram, yStation} = this;

        const destroyDraft = yDraft => {
            yDraft.unobserveDeep(deepObserver);
            yDraft.doc.provider.destroy();
            yDraft.doc.destroy();
        };

        destroyDraft(yPersonal);
        destroyDraft(yProgram);
        destroyDraft(yStation);
    }
}

RundownDraftsCtrl.$inject = [
    '$compile',
    '$http',
    '$scope',
    'selector',
    '$state',
    '$rootScope',
    'rundownInfo',
    'widgets',
    'UserFilters',
    'itemModelTypes',
    'masterStationInfo',
    'yConnection',
    'yDraftConnections',
];

module.exports = RundownDraftsCtrl;